export const getFlooredFixed = (v: number, d: number) => {
  return (Math.floor(v * Math.pow(10, d)) / Math.pow(10, d)).toFixed(d);
};
